export default class PopupPaymentCreateController {
    private static _instance: PopupPaymentCreateController | null = null;
    public popupOpenedFunction: Function | null = null;

    public static of() {
        if (this._instance === null) this._instance = new PopupPaymentCreateController();
        return this._instance;
    }
}